import { render, staticRenderFns } from "./AdminCell2.vue?vue&type=template&id=0f9d95bc&scoped=true&"
import script from "./AdminCell2.vue?vue&type=script&lang=js&"
export * from "./AdminCell2.vue?vue&type=script&lang=js&"
import style0 from "./AdminCell2.vue?vue&type=style&index=0&id=0f9d95bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d95bc",
  null
  
)

export default component.exports